import React from "react"
import { Link } from "react-router-dom"
import { Card, Container, Grid, Header, Icon } from "semantic-ui-react"
import { goalTypes } from "components/goals/goalTypes"
import { incomeTypes } from "components/incomes/incomeTypes"
import "./EmptyState.css"
import { useStore } from "store"
import { Loader } from "uikit"

export const EmptyState = ({ baseUrl, goalTypeOptions, employmentIncomes }) => {
  const goalTypeCards = goalTypeOptions.map(({ value }) => {
    const GoalIcon = goalTypes[value].icon
    return (
      <Card key={value} data-testid={`${goalTypes[value].label.toLowerCase()}`}>
        <Link to={`${baseUrl}/goals/new/${value}`} className="content">
          <Card.Content>
            <div>
              <GoalIcon width="80px" />
              <Header as="h4" content={`${goalTypes[value].label}`} />
            </div>
          </Card.Content>
        </Link>
      </Card>
    )
  })
  return (
    <Container textAlign="center" className="EmptyState__Container">
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <h2 className="EmptyState__Header">What's Important to You?</h2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <p className="EmptyState__Description">
              Let's start designing the future of your dreams by choosing your
              first goal
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="EmptyState__CardRow">
          <Grid.Column>
            <Card.Group itemsPerRow={goalTypeCards.length || 1}>
              {goalTypeCards}
            </Card.Group>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <p className="greyed-text">Don't see the goal you want?</p>
            <p className="greyed-text">
              <Link
                to={`${baseUrl}/goals/new`}
                className="navlink EmptyState__ContinueGoalLink"
              >
                Continue to see all available goals
                <Icon name="chevron right" size="small" />
              </Link>
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="EmptyState__BackToIntroRow">
          <Grid.Column>
            <Link
              to={`/${baseUrl.split("/")[1]}/introduction`}
              className="navlink"
            >
              <Icon name="chevron left" size="small" />
              back to introduction
            </Link>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  )
}

export const EmptyStateView = ({ scenario, household, baseUrl }) => {
  const [subscription] = useStore("subscriptions", household.id)
  const isCOVID =
    subscription && subscription.features && subscription.features.is_covid
  const [goalsObject] = useStore("scenarioGoals", scenario.id)
  const goals = Object.values(goalsObject)
  const [accountsObject] = useStore("householdAccounts", household.id)
  const householdAccounts = Object.values(accountsObject)
  const creditCardAccounts = householdAccounts.filter(
    account => account.type === "creditcard"
  )

  const [peopleObject] = useStore("householdPeople", household.id)
  const people = Object.keys(peopleObject).map(key => peopleObject[key])
  const [incomesObject] = useStore("householdIncomes", household.id)
  const incomes = Object.values(incomesObject)
  const existingGoalTypes = [...new Set(goals.map(goal => goal.type))]
  const nonCarriedAccounts = creditCardAccounts.filter(
    account => account.is_noncarried === false
  )
  const studentLoanAccounts = householdAccounts.filter(
    account => account.type === "studentloan"
  )
  var employmentIncomes = incomes.filter(
    income =>
      incomeTypes[income.type].cardType === "Employment" ||
      incomeTypes[income.type].cardType === "SelfEmployment"
  )
  const goalTypeOptions = Object.keys(goalTypes)
    .filter(
      goalType =>
        !(
          goalTypes[goalType].singular && existingGoalTypes.includes(goalType)
        ) &&
        !(
          goalTypes[goalType].cardType === "DebtPayoff" &&
          nonCarriedAccounts.length === 0
        ) &&
        !(
          goalTypes[goalType].cardType === "Retirement" &&
          (employmentIncomes.length === 0 || studentLoanAccounts.length !== 0)
        ) &&
        !(
          goalTypes[goalType].cardType === "StudentLoanPayoff" &&
          studentLoanAccounts.length === 0
        )
    )
    .filter(
      type =>
        goalTypes[type].showFirst &&
        goalTypes[type].showFirst({
          household,
          people
        })
    )
    .map(goalType => ({
      value: goalType,
      text: goalTypes[goalType].label
    }))

  if (isCOVID) {
    return <Loader />
  }
  return <EmptyState baseUrl={baseUrl} goalTypeOptions={goalTypeOptions} />
}
